export const DEFAULT_PROMPTS_AREA = {
    addressInfo: '',
    phoneInfo: '',
    vehicleInfo: '',
    promotionsInfo: '',
    otherInfo: '',
    isActive: false,
};

export const DEFAULT_STORE_ID = '60f5890cf852df12c8d10591';
